import { render, staticRenderFns } from "./Videoarchiv.vue?vue&type=template&id=3e2bc540&scoped=true"
import script from "./Videoarchiv.vue?vue&type=script&lang=js"
export * from "./Videoarchiv.vue?vue&type=script&lang=js"
import style0 from "./Videoarchiv.vue?vue&type=style&index=0&id=3e2bc540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2bc540",
  null
  
)

export default component.exports